import Login from "./../components/Auth/Login2";

export default Login;
